import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { Card, Text, Avatar, IconButton, useTheme } from 'react-native-paper';

const ChildCard = ({ 
  child, 
  onPress, 
  onEdit, 
  onDelete,
  showOptions = true 
}) => {
  const theme = useTheme();
  
  // Kız ve erkek çocuklar için farklı avatar renkleri (mor tema ile uyumlu)
  const getAvatarColor = () => {
    return child.gender === 'female' ? 'rgb(175, 82, 222)' : 'rgb(125, 76, 236)';
  };
  
  // Yaş gösterimi yardımcı fonksiyonu
  const getAgeDisplay = () => {
    // ageDisplay yoksa yaş hesaplama fonksiyonu kullan
    if (child.ageDisplay) {
      return child.ageDisplay;
    }
    
    // Eğer çocuk verisinde ageDisplay yoksa ve dateOfBirth varsa
    // Yaş hesaplama yardımcı fonksiyonu
    if (child.dateOfBirth) {
      const calculateAge = (dateOfBirth) => {
        const birthDate = new Date(dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        
        return age;
      };
      
      // Basit yaş formatı
      const age = calculateAge(child.dateOfBirth);
      return age > 0 ? `${age} yaşında` : '1 yaşından küçük';
    }
    
    // Son çare olarak doğrudan age değerini kullan
    return `${child.age || 0} yaşında`;
  };

  // Çocuk özelliklerini gösteren simgeler
  const renderBadges = () => {
    const badges = [];
    
    if (child.hasSpecialNeeds) {
      badges.push('alert-circle');
    }
    
    if (child.allergies) {
      badges.push('medical-bag');
    }
    
    return badges.length > 0 ? (
      <View style={styles.badgesContainer}>
        {badges.map((icon, index) => (
          <IconButton
            key={index}
            icon={icon}
            size={16}
            iconColor={icon === 'alert-circle' ? 'rgb(210, 50, 80)' : 'rgb(175, 82, 222)'}
            style={styles.badge}
          />
        ))}
      </View>
    ) : null;
  };

  return (
    <Card style={styles.card} onPress={onPress}>
      <Card.Content style={styles.content}>
        <View style={styles.avatarContainer}>
          <Avatar.Text 
            size={60} 
            label={child.name.substring(0, 2).toUpperCase()} 
            style={[styles.avatar, { backgroundColor: getAvatarColor() }]}
          />
        </View>
        
        <View style={styles.infoContainer}>
          <Text style={styles.name}>{child.name} {child.surname}</Text>
          <Text style={styles.detail}>Yaş: {getAgeDisplay()}</Text>
          <View style={styles.detailRow}>
            <Text style={styles.detail}>
              {child.gender === 'female' ? 'Kız' : 'Erkek'}
            </Text>
            {renderBadges()}
          </View>
        </View>
        
        {showOptions && (
          <View style={styles.buttonsContainer}>
            {onEdit && (
              <IconButton
                icon="pencil"
                iconColor="rgb(125, 76, 236)"
                size={20}
                onPress={() => {
                  console.log('Düzenle butonuna basıldı');
                  onEdit(child);
                }}
              />
            )}
            {onDelete && (
              <IconButton
                icon="delete"
                iconColor="rgb(210, 50, 80)"
                size={20}
                onPress={() => {
                  console.log('Sil butonuna basıldı');
                  onDelete(child);
                }}
              />
            )}
          </View>
        )}
      </Card.Content>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    marginVertical: 6,
    marginHorizontal: 12,
    elevation: 2,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
    backgroundColor: 'white',
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatarContainer: {
    marginRight: 12,
  },
  avatar: {
    marginRight: 10,
    
  },
  infoContainer: {
    flex: 1,
  },
  name: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'rgb(125, 76, 236)',
  },
  detail: {
    fontSize: 14,
    color: 'rgb(90, 50, 180)',
  },
  detailRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  badgesContainer: {
    flexDirection: 'row',
    marginLeft: 8,
  },
  badge: {
    margin: 0,
    padding: 0,
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

export default ChildCard;
